import React from 'react';
import AdminLayout from '../../../layout/AdminLayout';
import CompletionChart from '../../CompletionChart';
import ReportCsvDownload from '../../ReportCsvDownload';
import SpecialSaleLogList from '../../SpecialSaleLogList';
import TweetChart from '../../TweetChart';
import VisitorChart from '../../VisitorChart';
import { adminMutedText, adminSectionTitle } from '../../../layout/adminStyles';

const AdminStoreReportPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="space-y-5">
        <div>
          <p className="mb-1 text-xs font-medium uppercase tracking-[0.18em] text-teal-600">Analytics</p>
          <h2 className={adminSectionTitle}>レポート</h2>
          <p className={`${adminMutedText} text-sm`}>
            店舗ページのアクセス状況、つぶやきの投稿数、商品更新の完了日数、特売商品の履歴を確認できます。
          </p>
        </div>
        <ReportCsvDownload />
        <VisitorChart />
        <TweetChart />
        <CompletionChart />
        <SpecialSaleLogList />
      </div>
    </AdminLayout>
  );
};

export default AdminStoreReportPage;
